import React from 'react'
import PropTypes from 'prop-types'
import { Checkbox, FormControlLabel } from '@mui/material'
import styled from '@emotion/styled'

const FormGroupLabelWrap = styled(FormControlLabel)(({ theme }) => `
  & .MuiCheckbox-root svg {
    // background: ${theme.components.MuiCheckbox.styleOverrides.backgroundColor}; // NA
  }
  & .MuiCheckbox-root svg path {
    fill: ${theme.components.MuiCheckbox.styleOverrides.borderColor};
  }
  & .MuiTypography-root {
    font-size: 12px;
    white-space: nowrap;
    font-weight: 300;
    color: ${theme.components.MuiCheckbox.styleOverrides.color};
  }
  & .MuiTypography-root.Mui-disabled {
    color: ${theme.components.MuiCheckbox.styleOverrides.disabledColor};
  }
`)

const MuiCheckbox = ({ value, name, onChange, checked = false, label = '', disabled = false }) => {
  return (
    <FormGroupLabelWrap
      label={label}
      disabled={disabled}
      onChange={onChange}
      className='formCheckbox'
      control={<Checkbox name={name || value} value={value || name} checked={checked} />}
    />
  )
}

MuiCheckbox.propTypes = {
  onChange: PropTypes.func,
  checked: PropTypes.bool,
  name: PropTypes.string,
  value: PropTypes.string,
  label: PropTypes.string,
  disabled: PropTypes.bool
}

export default MuiCheckbox
